import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Brain } from 'lucide-react';

function formatDateTime(iso) {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }); }
  catch { return '—'; }
}

const OUTCOME_STYLE = {
  resolved: 'text-emerald-700 border-emerald-300 bg-emerald-50',
  ongoing: 'text-amber-700 border-amber-300 bg-amber-50',
  escalated: 'text-rose-700 border-rose-300 bg-rose-50',
};

/**
 * Day 12 — Behaviour Observation Chart trend card (minimal, read-only).
 */
export function BehaviourTrendCard({ trend }) {
  if (!trend) return null;
  const {
    latest_observation_time,
    last_7d_entry_count,
    last_7d_outcome_counts,
  } = trend;
  const counts = last_7d_outcome_counts || { resolved: 0, ongoing: 0, escalated: 0 };
  return (
    <Card data-testid="behaviour-trend-card" className="border-violet-200">
      <CardContent className="py-3 space-y-2">
        <div className="flex items-center gap-1.5 text-sm font-semibold text-violet-700">
          <Brain className="w-4 h-4" />
          Behaviour — 7-day snapshot
        </div>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-2 text-xs">
          <div className="rounded-md border bg-violet-50/60 px-3 py-2" data-testid="behaviour-trend-latest">
            <div className="text-[10px] uppercase tracking-wide text-muted-foreground">Latest observation</div>
            <div className="text-xs font-medium text-violet-800">{formatDateTime(latest_observation_time)}</div>
          </div>
          <div className="rounded-md border bg-violet-50/60 px-3 py-2" data-testid="behaviour-trend-7d-count">
            <div className="text-[10px] uppercase tracking-wide text-muted-foreground">Entries (7d)</div>
            <div className="text-base font-semibold text-violet-800">{last_7d_entry_count ?? 0}</div>
          </div>
          {['resolved', 'ongoing', 'escalated'].map(k => (
            <div
              key={k}
              className={`rounded-md border px-3 py-2 ${OUTCOME_STYLE[k] || ''}`}
              data-testid={`behaviour-trend-outcome-${k}`}
            >
              <div className="text-[10px] uppercase tracking-wide">{k}</div>
              <div className="text-base font-semibold">{counts[k] ?? 0}</div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}

export default BehaviourTrendCard;
